import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '../core/route.service';
import { extract } from '../core/i18n.service';
import { CreateProcessComponent } from 'app/createProcess/createProcess.component';

const routes: Routes = Route.withShell([
  { path: 'process/editing/create', component:  CreateProcessComponent, data: { titleKey: 'PROCESS.CREATE.PAGE_TITLE' } }
], false);

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class CreateProcessRoutingModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/createProcess/createProcess-routing.module.ts